import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <>
        <footer>
          <div className="" style={{ background: "#737070" }}>
            <div className="container">
              <div className="ft-widget-area footer_main_div">
                <div className="row">
                  <div className="col-md-3 col-sm-6">
                    <div className="ft-area1">
                      <div className="swin-widget swin-widget-about">
                        <div className="clearfix">
                          <div className="header-logo">
                            <img
                              src="./assets/images/logo/footer-logo1.jpg"
                              alt="IFC"
                              className="logo-img site_logo"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="ft-area1">
                          <div className="swin-widget widget-about">
                            <div className="title-widget footer_heading">
                              Lobby Reception
                            </div>
                            <div className="about-contact-info clearfix">
                              <div className="info-content phone-content">
                                <div className="info-icon">
                                  <i className="fa fa-phone"></i>
                                </div>
                                <div className="info-text">
                                  <p>+63 2 775 69002 / loc. 49001</p>
                                </div>
                              </div>
                              <div className="info-content email-content">
                                <div className="info-icon">
                                  <i className="fa fa-envelope"></i>
                                </div>
                                <div className="info-text">
                                  <p>mnl.receptionist@jpmchase.com</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="ft-area1">
                          <div className="swin-widget widget-about">
                            <div className="title-widget footer_heading">
                              Conference Center
                            </div>
                            <div className="about-contact-info clearfix">
                              <div className="info-content phone-content">
                                <div className="info-icon">
                                  <i className="fa fa-phone"></i>
                                </div>
                                <div className="info-text">
                                  <p>+63 2 775 69002 / loc. 49002</p>
                                </div>
                              </div>
                              <div className="info-content email-content">
                                <div className="info-icon">
                                  <i className="fa fa-envelope"></i>
                                </div>
                                <div className="info-text">
                                  <p>mnl.planners@jpmchase.com</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="ft-area1">
                          <div className="swin-widget widget-about">
                            <div className="title-widget footer_heading">
                              Employee Dining
                            </div>
                            <div className="about-contact-info clearfix">
                              {/* <div className="info-content phone-content">
                                <div className="info-icon">
                                  <i className="fa fa-phone"></i>
                                </div>
                                <div className="info-text">
                                  <p>+632 7756 3693 / ext. 63693</p>
                                </div>
                              </div> */}
                              <div className="info-content email-content">
                                <div className="info-icon">
                                  <i className="fa fa-envelope"></i>
                                </div>
                                <div className="info-text">
                                  <p>mnl.dining@jpmchase.com</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="ft-area1">
                          <div className="swin-widget widget-about">
                            <div className="title-widget footer_heading">
                              Pantry Services
                            </div>
                            <div className="about-contact-info clearfix">
                              {/* <div className="info-content phone-content">
                                <div className="info-icon">
                                  <i className="fa fa-phone"></i>
                                </div>
                                <div className="info-text">
                                  <p>+632 7756 3692 / ext. 63692</p>
                                </div>
                              </div> */}
                              <div className="info-content email-content">
                                <div className="info-icon">
                                  <i className="fa fa-envelope"></i>
                                </div>
                                <div className="info-text">
                                  <p>mnl.dining@jpmchase.com</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
